export const hashNumber = (value: number): number => ((value | 0) + 843517583) | 0
